import ManagementPageHTML, {
  IdentityCell,
  StatusBadge,
} from "../../components/ManagementPage/ManagementPageHTML";
import type { Supplier } from "../../models/Supplier";
import { Status } from "../../models/Status";
import { SupplierService } from "../../services/SupplierService";
import { useAuth } from "../../auth/useAuth";
export default function SupplierHTML() {
  const { hasPermission } = useAuth();
  return (
    <ManagementPageHTML<Supplier>
      Title="Suppliers"
      Eyebrow="Purchasing"
      Description="Manage supplier contacts and business details."
      AddLabel="Add supplier"
      SearchPlaceholder="Search supplier name or phone"
      Rows={[]}
      Summaries={[]}
      CanExport={false}
      Service={SupplierService()}
      CanCreate={hasPermission("Supplier.Manage")}
      CanEdit={hasPermission("Supplier.Manage")}
      CanDelete={hasPermission("Supplier.Manage")}
      DefaultValues={{ Status: Status.Active }}
      Statuses={Object.values(Status)}
      GetStatus={(x) => x.Status}
      GetRowKey={(x) => x.Code}
      GetSearchText={(x) => `${x.Code} ${x.Name} ${x.BusinessPhones ?? ""}`}
      Columns={[
        {
          Key: "Name",
          Header: "Supplier",
          Render: (x) => (
            <IdentityCell
              Icon="fa-truck-field"
              Title={x.Name}
              Subtitle={x.Code}
            />
          ),
        },
        {
          Key: "Contact",
          Header: "Contact",
          Render: (x) => <span>{x.BusinessPhones || "—"}</span>,
        },
        { Key: "Address", Header: "Address", Render: (x) => x.Addresse || "—" },
        {
          Key: "Status",
          Header: "Status",
          Render: (x) => <StatusBadge Status={x.Status} />,
        },
      ]}
      DialogFields={[
        { Key: "Code", Label: "Supplier code", Disable: true },
        { Key: "Name", Label: "Name", Required: true },

        { Key: "BusinessPhones", Label: "Business phones" },
        {
          Key: "Addresse",
          Label: "Address",
          Type: "textarea",
          FullWidth: true,
        },
        {
          Key: "BusinessDescription",
          Label: "Business description",
          Type: "textarea",
          FullWidth: true,
        },
        {
          Key: "Status",
          Label: "Status",
          Type: "select",
          Options: Object.values(Status),
          Required: true,
        },
      ]}
      GetSummaries={(rows, total) => [
        {
          Label: "Suppliers",
          Value: total,
          Icon: "fa-truck-field",
          Tone: "Blue",
        },
        {
          Label: "Active on this page",
          Value: rows.filter((x) => x.Status === Status.Active).length,
          Icon: "fa-check",
          Tone: "Green",
        },
      ]}
    />
  );
}
